import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";
import './Contact.css'

function Contact() {
    const handleLocationClick = (e) => {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );
        
        if (isMobile) {
            e.preventDefault();
            // Fixed: removed extra comma and added proper query parameter
            window.location.href = "geo:25.281448,51.4990685?q=25.281448,51.4990685(Engineering Cubes)";
        }
    };

    return (
        <div className="Entire-Contact">
            <Navbar/>

            <div className="Middle-part-Contact">
                <div className="Middle-part-location">
                    Our Location is at: Al sadd, Royal Plaza mall, 4th floor, HUB business center, room 29
                    <a 
                        href="https://maps.app.goo.gl/z9Ak1NHhGP2c1cSp9"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleLocationClick}
                    >
                        Get Directions
                    </a>
                </div>

                <div className="Middle-part-manager-contact">
                    You can contact the Engineering Manager at +974 5584 7552 for any inquiries. Mr Imad Alomar.
                </div>
            </div>

            <Footer/>
        </div>
    )
}

export default Contact;